import { QRCodeCanvas } from 'qrcode.react';
import { LookbookBrand } from '@/types/activation/lookbook';

/** Brand logo, or a gradient initial tile when the Genie has no logo. */
export const BrandMark = ({
  brand,
  size = 40,
  radius = 8,
}: {
  brand: LookbookBrand;
  size?: number;
  radius?: number;
}) => {
  if (brand.logoUrl) {
    return (
      <img
        src={brand.logoUrl}
        crossOrigin="anonymous"
        alt=""
        style={{ width: size, height: size, objectFit: 'contain', borderRadius: radius, display: 'block' }}
      />
    );
  }
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: radius,
        background: `linear-gradient(135deg, ${brand.primary}, ${brand.secondary})`,
        color: '#fff',
        fontWeight: 800,
        fontSize: size * 0.5,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        lineHeight: 1,
      }}
    >
      {brand.name.charAt(0).toUpperCase()}
    </div>
  );
};

/**
 * White QR tile with a soft shadow and a centred brand mark over a white
 * backing (visual excavation — QR is level H so this stays scannable). Uses
 * QRCodeCanvas so html2canvas captures it reliably as raster.
 */
export const LookbookQR = ({
  brand,
  size = 160,
  pad = 14,
}: {
  brand: LookbookBrand;
  size?: number;
  pad?: number;
}) => {
  const inner = size - pad * 2;
  const markBack = Math.round(inner * 0.26);
  const markSize = Math.round(inner * 0.2);
  return (
    <div
      style={{
        width: size,
        height: size,
        background: '#fff',
        borderRadius: 18,
        boxShadow: '0 12px 32px rgba(15,23,42,.16)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
      }}
    >
      <QRCodeCanvas value={brand.qrUrl} size={inner} level="H" fgColor="#15233A" bgColor="#ffffff" />
      <div
        style={{
          position: 'absolute',
          width: markBack,
          height: markBack,
          borderRadius: 12,
          background: '#fff',
          boxShadow: '0 0 0 4px #fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <BrandMark brand={brand} size={markSize} radius={7} />
      </div>
    </div>
  );
};

/** The "Powered by Help Genie" gradient pill used in tiles and footers. */
export const PoweredByPill = ({ scale = 1 }: { scale?: number }) => (
  <div
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 6 * scale,
      padding: `${5 * scale}px ${11 * scale}px`,
      borderRadius: 999,
      background: 'linear-gradient(90deg, #4E9CFF 0%, #FF4DB8 100%)',
      color: '#fff',
      fontSize: 11 * scale,
      fontWeight: 600,
      letterSpacing: '0.01em',
      lineHeight: 1,
    }}
  >
    Powered by Help Genie
  </div>
);
